<template>
    <ac-modal title="Network Invoice Groups" ref="modalRef" :size-class="'modal-md'">
        <div>
            <div class="alert alert-warning">
                <p>
                    Groups under the network mediator are automatically included for group invoices.
                </p>
            </div>
            <div>
                <div>
                    <input placeholder="Search..." class="form-control" type="text" v-model="searchQuery">
                </div>
            </div>
            <hr>
            <div style="max-height: 400px; overflow-y: auto;">
                <ul class="list-group">
                    <li v-for="company in filteredCompanies" :key="company.companyId" class="align-items-center">
                        <input
                            class="form-check-input"
                            type="checkbox"
                            :id="'company-' + company.companyId"
                            v-model="company.isLinkedToProvider"
                            :disabled="company.isUnderMediator"/>
                        <label class="form-check-label" :for="'company-' + company.companyId">
                            {{ company.companyName }}
                        </label>
                    </li>
                </ul>
            </div>
            <div class="modal-footer">
                <div class="button-box">
                    <ac-button class="btn btn-sm btn-red" :action="closeModal">CANCEL</ac-button>
                    <ac-button class="btn btn-sm btn-green" :action="save">SAVE</ac-button>
                </div>
            </div>
        </div>
    </ac-modal>
</template>

<script>
    import {api} from "../../../../global/framework/api.js";
    
    export default {
        name: "ProviderEntityInvoiceCompanyModal",
        
        data() {
            return {
                companys: [],
                searchQuery: ''
            };
        },
        computed: {
            filteredCompanies() {
                if (!this.searchQuery) {
                    return this.companys;
                }

                const query = this.searchQuery.toLowerCase();
                return this.companys.filter(x =>
                    x.companyName.toLowerCase().includes(query)
                );
            },
        },
        methods: {
            async showModal(data) {
                this.providerEntityId = data.providerEntityId;
                this.companys = await api.getDataById('invoice', 'GetProviderEntityInvoiceCompanys', this.providerEntityId);
                this.filteredCompanies = this.companys;
                // console.log("showModal companys:",this.companys);
                this.$refs.modalRef.open();        
            },
            closeModal() {
                this.$refs.modalRef.close();
            },
            async save() {
                let selectedIds = this.companys
                    .filter(c => c.isLinkedToProvider)
                    .map(c => c.companyId);
                // console.log("save selectedIds:", selectedIds);
                await api.postDataAsJson('invoice', `SaveProviderEntityInvoiceCompanys/${this.providerEntityId}`, selectedIds);
                this.closeModal();
            }
        }
    }
</script>

<style scoped>
    .modal-footer {
        padding-left: 0;
        padding-right: 0;
    }
</style>